export enum PublishingStatus {
  Draft = 'draft',
  Finished = 'finished',
  Published = 'published',
  Scheduled = 'scheduled',
}
